var Handlebars = require("handlebars/runtime");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<tbody>\n    <tr class=\"mkts-cmpt-svgcht-search-category\">\n    </tr>\n</tbody>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./components/svgchart/src/html/menuBar/autocompleteCategoryFullScreen.html
// module id = 34
// module chunks = 0